// extracted by mini-css-extract-plugin
export var title = "Heading-module--title--3uNQI";
export var paragraphs = "Heading-module--paragraphs--TiEb0";